import React from 'react';

export default function useBroadcastChannel<BroadcastChannelMessage>(
  name: string,
) {
  const [message, setMessage] = React.useState<BroadcastChannelMessage>();
  const channel = React.useRef<BroadcastChannel>();

  React.useEffect(() => {
    channel.current = new BroadcastChannel(name);

    channel.current.addEventListener('message', (event) => {
      setMessage(event.data);
    });

    return () => {
      channel.current?.close();
    };
  }, [name]);

  const sendMessage = React.useCallback((data: MessageEvent['data']) => {
    channel.current?.postMessage(data);
  }, []);

  return {
    message,
    sendMessage,
  };
}
